import { autorun, computed } from 'mobx';
import { observable } from 'mobx';

import { localeStrings as strings } from 'applicationConfig';

class SettingsStore {
  @observable _hasPageLoaded = null;
  @observable notificationState = { show: false, message: null };

  setAlertData(notificationState) {
    //{ message, title, ChildElement }
    this.notificationState = { show: true, ...notificationState };
  }

  showSimpleAlert(message) {
    return this.setAlertData({ message });
  }

  showSimpleError(message) {
    return this.setAlertData({ message, title: strings.generic.error });
  }

  clearAlert() {
    this.notificationState = { show: false, message: null, children: null };
  }

  onPageMountingStart(pageName, dataLoaded) {
    autorun(() => {
      this._hasPageLoaded = typeof dataLoaded !== 'undefined' ? dataLoaded.get() : false;
    });
  }

  onPageMountingEnd(pageName) {
    //
  }

  get isPageLoading() {
    return computed(() => {
      return this._hasPageLoaded;
    }).get();
  }
}

export default new SettingsStore();



// WEBPACK FOOTER //
// ./src/stores/SettingsStore.js